import { Injectable } from "@angular/core"
import { AbstractControl } from '@angular/forms';
import { UserService } from '../user.service';

@Injectable()

export class EmailTaken {
    constructor( 
        private userService: UserService 
    ) { }
    private validatorTimeout: any;

    validate(control: AbstractControl) {
        clearTimeout(this.validatorTimeout);
        return new Promise(resolve =>
            this.validatorTimeout = setTimeout(() => {
                const data = {email: control.value};
                if (data) {
                    this.userService.checkEmailAvailable(data).subscribe((res: any) => {
                        resolve(res ? null : { emailTaken: true } );
                    })
                }
            }, 600)
        )
    }
}


// WEBPACK FOOTER //
// ./src/app/services/validators/email-taken.validator.ts